import React from "react";
import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { SITE } from "@/data/config";
import { Overline } from "@/components/Primitives";

const LINKS = [
  { label: "Services", to: "/services" },
  { label: "Needs", to: "/needs" },
  { label: "Industries", to: "/industries" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Contact", to: "/contact" },
];

const NotFound = () => {
  useSeo({
    title: "That page is not here anymore. | Kostaja Ltd.",
    description: "The page may have moved during the Kostaja site rebuild. Start with the closest useful path.",
    noindex: true,
  });
  return (
    <main data-testid="not-found-page" className="bg-black min-h-[70vh] text-white">
      <div className="max-w-3xl mx-auto px-5 lg:px-10 py-24">
        <Overline className="mb-4">404</Overline>
        <h1 className="text-5xl lg:text-7xl font-black tracking-tight leading-[0.92]">
          That page is not here anymore.
        </h1>
        <p className="mt-5 text-white/75 text-lg max-w-xl">
          The page may have moved during the Kostaja site rebuild. Start with the closest useful path below.
        </p>
        <ul className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/10 border border-white/15">
          {LINKS.map((l) => (
            <li key={l.to} className="bg-black">
              <Link
                to={l.to}
                data-testid={`nf-link-${l.to.replace(/\//g, "")}`}
                className="group block p-6 hover:bg-[#FFC600] hover:text-black transition-colors"
              >
                <div className="text-[10px] uppercase tracking-[0.22em] font-bold k-yellow group-hover:text-black">Go to</div>
                <div className="mt-1 text-2xl font-black tracking-tight">{l.label} →</div>
              </Link>
            </li>
          ))}
          <li className="bg-black">
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="nf-book"
              className="group block p-6 hover:bg-[#FFC600] hover:text-black transition-colors"
            >
              <div className="text-[10px] uppercase tracking-[0.22em] font-bold k-yellow group-hover:text-black">External</div>
              <div className="mt-1 text-2xl font-black tracking-tight">Start a Project ↗</div>
            </a>
          </li>
        </ul>
      </div>
    </main>
  );
};

export default NotFound;
